import { Cancel, CheckCircle } from '@mui/icons-material'
import { Box } from '@mui/material'

interface Props {
  text: string
  value: boolean
  dataTestId: string
}
export const FocusStudentSubmittedCheckbox = (props: Props): JSX.Element => {
  return <>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '.25rem'
      }}
      data-testid={props.dataTestId}
    > {props.text} {props.value
      ? <CheckCircle
          sx={{
            fontSize: '12px',
            color: 'var(--green-700)'
          }}
          data-testid='checkIcon'
      />
      : <Cancel
          sx={{
            fontSize: '12px',
            color: 'var(--red-700)'
          }}
          data-testid='cancelIcon'
      />}
    </Box>

  </>
}
